import { render, staticRenderFns } from "./DiscountsForm.vue?vue&type=template&id=94cf1908&scoped=true&"
import script from "./DiscountsForm.vue?vue&type=script&lang=js&"
export * from "./DiscountsForm.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsForm.vue?vue&type=style&index=0&id=94cf1908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf1908",
  null
  
)

export default component.exports